export enum Gender {
  UNDEFINED = 'UNDEFINED',
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum RacialDenomination {
  UNDEFINED = 'UNDEFINED',
  WHITE = 'WHITE',
  BROWN = 'BROWN',
  BLACK = 'BLACK',
  ORIENTAL = 'ORIENTAL',
  INDIGENOUS = 'INDIGENOUS',
}

export interface PreassureMeasurement {
  systolic: number;
  diastolic: number;
}

export interface IgnoreMeasurements {
  ignoreAll: boolean;
  ignoreBpm: boolean;
  ignorebloodO2Saturation: boolean;
  ignorebloodPreassure: boolean;
  ignoreRespiratoryRate: boolean;
  ignoreGlucose: boolean;
}

export interface WorkflowMeasurements {
  bloodO2Saturation: number;
  bloodPreassure: PreassureMeasurement;
  bpm: number;
  respiratoryRate: number;
  glucose: number;
  //
  ignore: IgnoreMeasurements;
}

export interface WorkflowStudy {
  tags: string[];
  phone: string[];
  oximeterModel: string[];
  pressureGaugeModel: string[];
  glucoseExtraInfo: string[];
  extraDescription: string;
}

export interface WorkflowPerson {
  alias?: string;
  height: number;
  weight: number;
  age: number;
  gender: Gender;
  racialDenomination: RacialDenomination;
  extraDescription: string;
}

export enum WavelightMode {
  ANALYSIS = 'ANALYSIS',
  APPLICATION = 'APPLICATION',
}

export interface WavelightSecureDto {
  id: string;
  createdAt: Date;
  updatedAt: Date;

  mode: WavelightMode;
}

// Algorithms and Waves
export enum WavelightAlgorithms {
  UNDEFINED = 'UNDEFINED',
  AVERAGE_OF_COLORS = 'AVERAGE_OF_COLORS',
  PPG_EXTRACTOR = 'PPG_EXTRACTOR',
}

export interface Wave {
  _id: string;

  createdAt: Date;
  updatedAt: Date;

  wavelight_id: string;

  algorithm: WavelightAlgorithms;
  version: string;
  computing: boolean;
  configuration: any;
  data: any;
  process_time_taken: number;
  download_time_taken: number;
}

export enum WaveTechniques {
  UNDEFINED = 'UNDEFINED',
  HEART_BEATS = 'HEART_BEATS',
}

export interface Technique {
  _id: string;

  createdAt: Date;
  updatedAt: Date;

  wave_id: string;
  wavelight_id: string;

  technique: WaveTechniques;
  version: string;
  computing: boolean;
  configuration: any;
  data: any;
  process_time_taken: number;
}

export interface Pagination {
  page: number;
  limit: number;
}
